import type {
  FormType,
  VisitCategory,
} from "@/api/form-builder-assignments/formBuilderAssignments.types";
import { CATEGORY_FORM_TYPE_SLOTS, getCategoryMeta } from "../constants/assignments.constants";

/** "Reactive Further Assessment": how the page names a slot. */
export function slotLabelOf(workOrderType: VisitCategory, formType: FormType): string {
  const slot = CATEGORY_FORM_TYPE_SLOTS.find((s) => s.formType === formType)?.label ?? formType;
  return `${getCategoryMeta(workOrderType).label} ${slot}`;
}
